const styles = {
  container: 'w-full md:col-span-6',
  content: 'flex flex-col gap-y-4',

  foot: 'flex flex-row items-center justify-between h-4',

  label: ' !text-sm font-bold !text-black dark:!text-white',
  description: ' text-xs text-gray-600',
  error: 'text-primary-500 text-lg text-left',

  submit: {
    container: 'w-full flex flex-col items-end justify-end ',
    content: 'flex flex-row items-center gap-x-2',

    button:
      '!bg-black dark:!bg-white dark:text-black text-white !text-sm font-bold !py-6 mt-16 hover:!bg-black/80 dark:hover:!bg-white/80 duration-300',
    icon: 'text-xs',
  },
};

export default styles;
